import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export default function Button(props) {
  return (
    <button
      {...props}
      class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
    >
      {props?.loading === true ? (
        <ClipLoader color="white" size={20} />
      ) : (
        props?.title
      )}
    </button>
  );
}
